<template>
	<div style="height: 100px;">
		<div class="phone w-100" style="z-index: 100; position: fixed; top:0px; right: 0;">
			<div class="content">
				<nav role="navigation overflow-hidden" class="bg-white pt-3 pb-3 " style="box-shadow: 0 0 5px 1px #888888;">
					<div class="float-right col-4" style="height:100%;">
						<img 
							width="24" class="pointer" style="margin-top: 5px;" :src="img.M3" @click="mnu1 = !mnu1;  mnu2 = false;"
							v-show="!mnu1"
						/>
						<img 
							class="pointer" 
							style=" height: 100%;" 
							:src="require('../assets/img/input_x.svg')"
							@click="mnu1 = !mnu1;  mnu2 = false;"
							v-show="mnu1"
						/>
						
					</div>

					<div class="float-right col-4 text-center" style="height:100%;">
						<a href="/" class="text-center" id="mobile_header_logo_link">
							<img class="pointer" style="    height: 100%;" :src="img.Logo_Header"/>
						</a>
					</div>

					<div class="float-right col-4 text-left" style="height:100%;">
						<img width="24" class="pointer" style="margin-top: 5px; " :src="img.M4" @click="mnu2 = !mnu2; mnu1 = false;" v-if="$localStorage.get('user')!=null"	/>
					</div>
				</nav>

				<div
					class="text-center shadow"
					style="background: white;
					width: 50%;
					position: absolute;
					top: 65px;
					height: 95vh;
					border-left: 1px solid #eee;
					overflow: auto;"
					v-show="mnu1"
				>
					<img class="pointer" style="margin-top: 5px; width:75%; max-height: 65px;" :src="img.LogoFooter" />
					<hr class=" w-75" />
					<!-- ________________________________________________________________________ -->
					<a href="https://siadat.net/" >
						<btn
							id_btn="menuMobile_home"
							shadow="0"
							class="w-100"
							textClass="w-100 text-right"
							style_btn="display: block;"
							type="white"
							text="خانه"
						/>
					</a>
					<!-- ________________________________________________________________________ -->
					<!-- <a href="https://blog.ticket.siadat.net/" target="_blank">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right"
							style_btn="display: block;"
							type="white"
							text="مقالات"
						/>
					</a> -->
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/aboutMe" v-if="chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right"
							style_btn="display: block;"
							type="white"
							text="درباره ما"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<router-link to="/signup_all" v-if="$localStorage.get('user')==null && chechRole()">
						<btn
							shadow="0"
							class="w-100"							
							textClass="w-100 text-right"
							style_btn="display: block;"

							type="white"
							text="ثبت نام"
						/>
					</router-link>
					<!-- ________________________________________________________________________ -->
					<router-link to="/oneTimePassword" v-if="$localStorage.get('user')==null && chechRole()">
						<btn
							shadow="0"
							class="w-100"
							
							textClass="w-100 text-right text-successt"
							style_btn="display: block;"
							type="white"
							text="ورود"
						/>
					</router-link>
					<!-- ________________________________________________________________________ -->
				</div>
				<!-- ---------------------------------------------------------------------------------------- -->


				<div
					class="text-center shadow border-15"
					style="background: white;
					width: 50%;
					position: absolute;
					top: 70px;
					border-left: 1px solid #eee;
					left: 5;
					overflow: auto;"
					v-show="mnu2"
				>
					<!-- ________________________________________________________________________ -->
					 <span v-if="$localStorage.get('user')!=null && chechRole()">
						 <router-link to="/signupTeacher"  v-if="$localStorage.get('user').username.role==2">
							 <btn
							 shadow="0"
							 class="w-100"
							 textClass="w-100 text-right "
							 style_btn="display: block;"
							 type="white"
							 text="پروفایل"
							 />
							</router-link>
						</span>
					<!-- ________________________________________________________________________ -->
					 <!-- <span v-if="$localStorage.get('user')!=null && chechRole()">
						 <router-link to="/dashboard_user"  v-if="$localStorage.get('user').username.role==1">
							 <btn
							 shadow="0"
							 class="w-100"
							 textClass="w-100 text-right "
							 style_btn="display: block;"
							 type="white"
							 text="داشپورت"
							 />
							</router-link>
						</span> -->
					<!-- ________________________________________________________________________ -->
					<router-link to="/ticket/list">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="تیکت‌ها"
						/>
					</router-link>
					<!-- ________________________________________________________________________ -->
					<router-link to="/users" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="کاربران"
						/>
					</router-link>
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/category/list" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="دسته بندی ها"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/degrees/list" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="مقاطع تحصیلی"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<router-link to="/field/list" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="دپارتمان"
						/>
					</router-link>
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/category/list" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="موضوع درس"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/auditors/list" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="هیئت ممیزه"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/discount/list" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="تخفیف ها"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/payment/list" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="تراکنش های مالی"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/support/chat" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="پیام ها"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<router-link to="/admin/list" v-if="!chechRole()">
						<btn
							shadow="0"
							class="w-100"
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="مدیران"
						/>
					</router-link>
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/class/list" v-if="$localStorage.get('user')!=null && chechRole()">
						<btn
							shadow="0"
							class="w-100"
							
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="مدیریت کلاس ها"
							v-if="$localStorage.get('user').username.role=='2'"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/self" v-if="$localStorage.get('user')!=null && chechRole()">
						<btn
							shadow="0"
							class="w-100"
							
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="ویرایش اطلاعات"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<!-- <router-link to="/self/setpass" v-if="$localStorage.get('user')!=null && chechRole()">
						<btn
							shadow="0"
							class="w-100"
							
							textClass="w-100 text-right "
							style_btn="display: block;"
							type="white"
							text="ویرایش کلمه عبور"
						/>
					</router-link> -->
					<!-- ________________________________________________________________________ -->
					<btn
						id_btn="exit_btn_id_web"
						shadow="0"
						class="w-100"
						textClass="w-100 text-right "
						style_btn="display: block;"
						type="outline-danger"
						text="خروج"
						v-if="$localStorage.get('user')!=null"
						@clickMe="exit(1)"
					/>
					<btn
						id_btn="exit_btn_id_mobile"
						shadow="0"
						v-show="false"
						class="w-100"
						textClass="w-100 text-right "
						style_btn="display: block;"
						type="outline-danger"
						text="خروج"
						v-if="$localStorage.get('user')!=null"
						@clickMe="exit(2)"
					/>
					<!-- ________________________________________________________________________ -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Logo_Header from '../assets/img/Logo_Header.svg';
	import M3 from '../assets/img/M3.svg';
	import M4 from '../assets/img/M4.svg';
	import ArrowDown from '../assets/img/Arrow_Down.svg';
	import LogoFooter from '../assets/img/Logo_Footer.svg';
	import btn from  "../UI/button/btn.vue";

	export default {
			name: 'menuMobile',
		data(){
			return {
				fileurl: window.location.origin.replace(":8081", ":8080")+"/biography/upload/",
				vcfurl: window.location.origin.replace(":8081", ":8080")+"/biography/vcf/",
				mnu1: false,
				mnu2: false,
				shwCat: false,
				phn: '',h:'',
				catNum: -1,
				img: {
					"Logo_Header": Logo_Header,
					"M3": M3,
					"M4": M4,
					"ArrowDown": ArrowDown,
					"LogoFooter": LogoFooter,
				}
			}
		},
			props: ["flds"],
		components: {
			btn,
		},
		mounted(){

		},
		methods:{
			chechRole(){
				let user = this.$localStorage.get('user');
				if(user == null){
					return true;
				}else if(user.username.role != 3){
					return true;
				}else{
					return false;
				}
			},
			//________________________________________________________________________
			exit(mod="1"){
				this.$swal.fire({
					position: 'center',
					type: '',
					title: "خروج از حساب",
					html: "<div class='text-center w-75 m-auto'><hr/> آیا مطمئن هستید می خواهید از حساب کاربری خود خارج شوید.</div>",
					showCloseButton: true,
					showConfirmButton: true,
					confirmButtonText: "خیر",
					confirmButtonClass:"btn btn-outline-success border w-50",
					showCancelButton: true,
					cancelButtonText: "بلی خروج!",
					cancelButtonClass:"btn btn-danger w-50",
				}).then((result) => {
					if (result.dismiss=="cancel") {
						this.$localStorage.remove('user');
							var rtr = (mod=="1") ? "/" : "/login";
							if(window.location.pathname == rtr){
								location.reload();
							} else {
								// this.$router.push(rtr);
								location.replace(rtr);
							}
					}
				})
			}
		}
	}
</script>

<style scope>
	@import "mobile.css";
</style>
